<template>
  <HeroSection />
  <FeaturedProducts />
  <WhyChoose />
  <Testimonials />
  <NewsletterSignUp />
</template>

<script>
import HeroSection from '@/components/HeroSection.vue';
import FeaturedProducts from '@/components/FeaturedProducts.vue';
import WhyChoose from '@/components/WhyChoose.vue';
import Testimonials from '@/components/Testimonials.vue';
import NewsletterSignUp from '@/components/NewsletterSignUp.vue';

export default {
  components: {
    HeroSection,
    FeaturedProducts,
    WhyChoose,
    Testimonials,
    NewsletterSignUp
  }
};
</script>
<style scoped>

</style>